module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.currentQuestion.data.choices), function(choice) {
    return _c('v-checkbox', {
      key: choice,
      attrs: {
        "value": choice,
        "label": choice
      },
      model: {
        value: (_vm.answers),
        callback: function($$v) {
          _vm.answers = $$v
        },
        expression: "answers"
      }
    })
  }), _vm._v(" "), (_vm.currentQuestion.data.otherChoice) ? _c('v-checkbox', {
    attrs: {
      "label": _vm.currentQuestion.data.otherLabel,
      "value": _vm.currentQuestion.data.otherLabel
    },
    model: {
      value: (_vm.answers),
      callback: function($$v) {
        _vm.answers = $$v
      },
      expression: "answers"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answers.includes(_vm.currentQuestion.data.otherLabel)) ? _c('v-text-field', {
    staticStyle: {
      "margin-top": "-1.5rem",
      "margin-left": "2.3rem"
    },
    attrs: {
      "label": "Précisez",
      "required": "",
      "single-line": ""
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-437ef058","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/additional/MultiChoice.vue
// module id = 322
// module chunks = 1